<template>
  <div id="categories-list">
    <v-snackbar
      v-model="isSnackbarVisible"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
      auto-height
    >
      <v-layout
        align-center
        pr-4
      >
        <v-icon
          class="pr-3"
          dark
          large
        >
          {{ snackbar.icon == 'success' ? icons.mdiCheckBold : icons.mdiCheckBold }}
        </v-icon>

        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>

    <!-- titulo -->
    <h2 class="m-2">
      SEGUIMIENTO ORDEN
    </h2>
    
    <!-- Botones para cambiar estilo del mapa -->
    <v-card class="mb-3">
      <v-card-text class="py-2">
        <div class="d-flex align-center flex-wrap">
          <span class="text-sm font-weight-medium mr-3">Vista del mapa:</span>
          <v-btn-toggle
            v-model="selectedMapStyle"
            mandatory
            dense
            color="primary"
            :disabled="isChangingStyle"
            @change="handleStyleChange"
          >
            <v-btn
              small
              value="mapbox://styles/mapbox/satellite-streets-v11"
            >
              <v-icon small left>
                {{ icons.mdiMapMarker }}
              </v-icon>
              Híbrido
            </v-btn>
            <v-btn
              small
              value="mapbox://styles/mapbox/satellite-v9"
            >
              <v-icon small left>
                {{ icons.mdiEarth }}
              </v-icon>
              Satélite
            </v-btn>
          </v-btn-toggle>
          
          <v-progress-circular
            v-if="isChangingStyle"
            indeterminate
            size="24"
            width="3"
            color="primary"
            class="ml-2"
          ></v-progress-circular>
          
          <v-spacer></v-spacer>
          
          <div class="d-flex align-center">
            <span class="text-sm mr-2">Zoom:</span>
            <v-btn
              icon
              x-small
              @click="zoomIn"
            >
              <v-icon>{{ icons.mdiPlus }}</v-icon>
            </v-btn>
            <v-btn
              icon
              x-small
              @click="zoomOut"
            >
              <v-icon>{{ icons.mdiMinus }}</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
    
    <v-card>
      <div
        v-if="showMap"
        id="map"
        style="height: 500px"
      >
        <MglMap
          :key="mapKey"
          :center.sync="center"
          :access-token="accessToken"
          :map-style.sync="mapStyle"
          :zoom="zoom"
          @load="onMapLoad"
        >
          <MglMarker
            v-for="(marker, ii) in coordinates"
            :key="`coord-${marker.id}-${ii}`"
            :coordinates="marker.coordinates"
          >
            <div slot="marker">
              <img
                :src="ii < coordinates.length - 1 ? '/yaqui/driverg.png' : '/yaqui/driver.png'"
                height="20px"
              />
              <img
                v-if="ii == 0"
                src="/yaqui/drivera.png"
                height="25px"
              />
            </div>
            <MglPopup>
              <div>
                <span style="font-size: 25px !important">{{
                  $moment(marker.comentario).utc().format('DD-MM-YYYY hh:mm:ss')
                }}</span>
              </div>
            </MglPopup>
          </MglMarker>
          <MglMarker
            v-for="(marker2, ii) in marcas"
            :key="`marca-${marker2.id}-${ii}`"
            :coordinates="marker2.coordinates"
          >
            <div slot="marker">
              <img
                :src="marker2.icon"
                height="30px"
              />
            </div>
          </MglMarker>
        </MglMap>
      </div>
    </v-card>
  </div>
</template>

<script>
import {
  mdiCheckBold,
  mdiDeleteOutline,
  mdiEarth,
  mdiInformation,
  mdiMapMarker,
  mdiMinus,
  mdiNavigation,
  mdiPencil,
  mdiPlus,
  mdiPlusCircle,
  mdiReload,
  mdiRoad,
  mdiWeatherNight,
  mdiWhiteBalanceSunny,
} from '@mdi/js'
import { ref } from '@vue/composition-api'

import {
  MglGeojsonLayer, MglGeolocateControl, MglMap, MglMarker, MglNavigationControl, MglPopup,
} from 'vue-mapbox'

// import UserListAddNew from './UserListAddNew.vue'
// import userStoreModule from '../userStoreModule'

// import useUsersList from './useUsersList'

export default {
  components: {
    MglMap,
    MglMarker,
    MglGeojsonLayer,
    MglNavigationControl,
    MglGeolocateControl,
    MglPopup,
  },
  data() {
    return {
      icons: {
        mdiDeleteOutline,
        mdiPencil,
        mdiPlusCircle,
        mdiCheckBold,
        mdiNavigation,
        mdiRoad,
        mdiEarth,
        mdiWeatherNight,
        mdiWhiteBalanceSunny,
        mdiMapMarker,
        mdiPlus,
        mdiMinus,
        mdiInformation,
        mdiReload,
      },
      items: [],
      table: 'seguimiento_orden',
      tableColumns: [
        { text: 'id', value: 'id', sortable: true },
        { text: 'Fecha Orden', value: 'fecha_orden', sortable: true },
        { text: 'Fecha Finalizado', value: 'fecha_finalizado', sortable: true },
        { text: 'Total', value: 'total', sortable: true },
        { text: 'Estado', value: 'estado', sortable: true },

        { text: 'Acciones', value: 'acciones', sortable: false },

        // {id:0, name:}
      ],
      loading: false,
      totalItems: 0,
      isDialogVisible: false,
      row: {},
      modalTitle: 'Nueva Orden',
      customersList: [],
      categoriesList: [],
      subcategoriesList: [],
      commerceList: [],
      formHasErrors: false,
      errorMessages: '',
      form: ref(null),
      valid: ref(true),
      isSnackbarVisible: false,
      message: '',
      messageColor: 'primary',
      icon: '',
      snackbar: {
        color: 'success',
        icon: 'check_circle',
        mode: 'multi-line',
        title: 'Success',
        text: 'That worked, hoorah.',
        visible: true,
      },
      statusList: [{ nombre: 'Activo' }, { nombre: 'Inactivo' }],

      accessToken: 'pk.eyJ1IjoieWFxdWkiLCJhIjoiY200NTVsdDR1MDYwbzJrb2phODM0dzN5ZCJ9.oBzYf5xlVu_iQUc47GLh1A',
      mapStyle: 'mapbox://styles/mapbox/satellite-streets-v11', // Estilo por defecto
      selectedMapStyle: 'mapbox://styles/mapbox/satellite-streets-v11', // Estilo seleccionado
      stateList: [{ name: 'Activo' }, { name: 'Pendiente' }],

      geojson: {
        type: 'FeatureCollection',
        features: [
          {
            properties: { name: 'south park' },
            geometry: {
              coordinates: [-95.2358865737915, 38.96194491354418],
            },
          },
          {
            properties: { name: 'Buford M Watson, Jr. Park' },
            geometry: {
              coordinates: [-95.23893356323242, 38.97148792405487],
            },
          },
        ],
      },
      layerId: 'firstLayer',
      sourceId: 'firstSource',
      coordinates: [],

      // coordinates: this.geojson,
      center: [-86.108508886867, 11.912447380368315],
      zoom: 15, // Aumentado para ver mejor los nombres de calles

      id: 0,
      Mymap: null,
      dataOrder: [],

      /// /////////
      puntosOrden: [],
      tiempo: null,
      distancia: null,
      marcas: [],
      lat: '',
      lng: '',
      mapLoaded: false,
      isLoadingMap: false,
      showMap: true,
      mapKey: 0,
      addedLayers: [],
      isChangingStyle: false,
    }
  },
  watch: {
    '$route.params.id': {
      handler(newId, oldId) {
        if (newId !== oldId && oldId !== undefined) {
          console.log('🔄 Cambio de ID detectado, recargando componente...')
          // Forzar recarga completa del componente
          this.showMap = false
          this.$nextTick(() => {
            this.mapKey = Date.now()
            this.showMap = true
          })
        }
      },
      immediate: false,
    },
    selectedMapStyle(newStyle, oldStyle) {
      if (oldStyle && newStyle !== oldStyle && this.Mymap && this.Mymap.map) {
        console.log('🎨 Cambiando estilo del mapa de:', oldStyle, 'a:', newStyle)
        
        this.isChangingStyle = true
        
        // Cambiar el estilo
        this.mapStyle = newStyle
        
        // Esperar a que el estilo se cargue completamente
        const checkStyleLoaded = () => {
          if (this.Mymap && this.Mymap.map && this.Mymap.map.isStyleLoaded()) {
            console.log('✅ Estilo cargado y renderizado completamente')
            this.isChangingStyle = false
          } else {
            // Seguir verificando
            setTimeout(checkStyleLoaded, 100)
          }
        }
        
        // Esperar a que el mapa esté listo
        this.Mymap.map.once('idle', () => {
          console.log('�️ Mapa en estado idle, verificando estilo...')
          checkStyleLoaded()
        })
        
      } else if (oldStyle && newStyle !== oldStyle) {
        // Si el mapa no está listo, solo cambiar el estilo
        this.mapStyle = newStyle
      }
    },
  },
  beforeDestroy() {
    // Limpiar el mapa y sus recursos
    console.log('Limpiando recursos del mapa...')
    this.mapLoaded = false
    this.isLoadingMap = false
    this.showMap = false
    this.addedLayers = []
    if (this.Mymap && this.Mymap.map) {
      // Remover todas las capas agregadas
      this.addedLayers.forEach(layerId => {
        try {
          if (this.Mymap.map.getLayer(layerId)) {
            this.Mymap.map.removeLayer(layerId)
          }
          if (this.Mymap.map.getSource(layerId)) {
            this.Mymap.map.removeSource(layerId)
          }
        } catch (e) {
          console.log('Error limpiando capa:', e)
        }
      })
    }
    this.Mymap = null
    console.log('Componente destruido, recursos limpiados')
  },
  async mounted() {
    try {
      console.log('=== MOUNTED: Iniciando carga de MapOrder ===')
      
      // Restaurar el estilo guardado si existe
      const savedStyle = localStorage.getItem('mapStyle')
      if (savedStyle) {
        this.mapStyle = savedStyle
        this.selectedMapStyle = savedStyle
        console.log('📍 Estilo restaurado:', savedStyle)
      }
      
      // Resetear flags y datos al montar
      this.mapLoaded = false
      this.isLoadingMap = false
      this.coordinates = []
      this.marcas = []
      this.addedLayers = []
      this.showMap = false // Ocultar mapa mientras se cargan datos
      this.mapKey = Date.now() // Key única para forzar re-render limpio
      
      this.id = this.$route.params.id
      await this.getData()

      if (this.items && this.items.length > 0) {
        // Verificar si las coordenadas del historial son válidas (Nicaragua está entre lat 10-15, lng -88 a -83)
        let hasValidCoordinates = false
        
        for (const item of this.items) {
          const lat = parseFloat(item.lat)
          const lng = parseFloat(item.lng)
          
          // Verificar si las coordenadas están en el rango de Nicaragua
          if (lat >= 10 && lat <= 15 && lng >= -88 && lng <= -83) {
            hasValidCoordinates = true
          }
          
          const data = {
            icon: '~/yaqui/driver.png',
            coordinates: JSON.parse(`[${item.lng}, ${item.lat}]`),
            id: item.id,
            comentario: item.fecha,
          }
          this.coordinates.push(data)
        }

        if (this.coordinates.length > 0 && hasValidCoordinates) {
          this.center = this.coordinates[0].coordinates
          console.log('=== MOUNTED: Datos cargados correctamente ===')
          console.log('📍 Centro inicial del mapa (desde historial):', this.center)
          console.log('📍 Total coordenadas historial:', this.coordinates.length)
          
          // Mostrar mapa después de que los datos estén listos
          await this.$nextTick()
          this.showMap = true
          console.log('✅ Mapa mostrado')
        } else if (this.puntosOrden && this.puntosOrden.length > 0) {
          // Si las coordenadas del historial no son válidas, usar el primer punto de la orden
          console.log('⚠️ Coordenadas del historial inválidas, usando puntos de orden')
          const primerPunto = this.puntosOrden[0].coordenadas_inicio.split(',')
          this.center = [parseFloat(primerPunto[1]), parseFloat(primerPunto[0])]
          console.log('📍 Centro desde punto de orden:', this.center)
          
          await this.$nextTick()
          this.showMap = true
          console.log('✅ Mapa mostrado')
        } else {
          console.log('⚠️ No hay coordenadas válidas para mostrar el mapa')
        }
      } else if (this.puntosOrden && this.puntosOrden.length > 0) {
        // Si no hay historial, usar el primer punto de la orden
        console.log('⚠️ No hay historial, usando puntos de orden')
        const primerPunto = this.puntosOrden[0].coordenadas_inicio.split(',')
        this.center = [parseFloat(primerPunto[1]), parseFloat(primerPunto[0])]
        console.log('📍 Centro desde punto de orden:', this.center)
        
        await this.$nextTick()
        this.showMap = true
        console.log('✅ Mapa mostrado')
      } else {
        console.log('⚠️ No hay items para procesar')
      }
    } catch (error) {
      console.error('Error en mounted:', error)
      this.isSnackbarVisible = true
      this.snackbar = {
        color: 'error',
        icon: 'error',
        title: 'Error',
        text: 'Error al cargar los datos del mapa',
      }
    }
  },
  methods: {
    async showDataOrderInMap(mapa) {
      try {
        if (!mapa || !mapa.map) {
          console.log('❌ Mapa no disponible')
          return
        }

        if (!this.puntosOrden || this.puntosOrden.length === 0) {
          console.log('No hay puntos de orden para mostrar')
          return
        }
        
        console.log('puntos orden', this.puntosOrden)
        let routeCounter = 0
        let hasApiError = false
        
        // Limitar el número de rutas para evitar sobrecarga
        const maxRoutes = 5
        let processedRoutes = 0
        
        for (const puntos of this.puntosOrden) {
          if (processedRoutes >= maxRoutes) {
            console.log('⚠️ Límite de rutas alcanzado')
            break
          }

          console.log('init for')
          if (puntos.id > 0) {
            console.log('if en for')

            const puntoIni = puntos.coordenadas_inicio.split(',')
            const puntoFin = puntos.coordenadas_entrega.split(',')
            console.log('punto inicio', puntoIni)
            console.log('punto fin', puntoFin)
            const endPoint = `https://api.mapbox.com/directions/v5/mapbox/driving-traffic/${puntoIni[1]}%2C${puntoIni[0]}%3B${puntoFin[1]}%2C${puntoFin[0]}?alternatives=true&geometries=geojson&language=en&overview=simplified&steps=true&access_token=pk.eyJ1IjoieWFxdWkiLCJhIjoiY200NTVsdDR1MDYwbzJrb2phODM0dzN5ZCJ9.oBzYf5xlVu_iQUc47GLh1A`

            // consumir servicio con timeout
            console.log('endPoint ////////////////////////', endPoint)
            
            const controller = new AbortController()
            const timeoutId = setTimeout(() => controller.abort(), 5000) // 5 segundos timeout
            
            try {
              const query = await fetch(endPoint, { 
                method: 'GET',
                signal: controller.signal,
              })
              clearTimeout(timeoutId)

              const resp = await query.json()
              
              // Verificar si hay error de autenticación
              if (resp.code === 'Unauthorized' || resp.message) {
                console.error('❌ Error de API Mapbox:', resp.message || 'Token inválido')
                hasApiError = true
                continue
              }
              
              if (!resp.routes || resp.routes.length === 0) {
                console.log('⚠️ No se encontraron rutas')
                continue
              }

              const coo2 = []
              let cooTmp = []
              if (resp.routes.length > 1) {
                cooTmp = resp.routes[1].geometry.coordinates
              } else {
                cooTmp = resp.routes[0].geometry.coordinates
              }

              for (const itt of cooTmp) {
                const tt1 = [itt[0], itt[1]]
                coo2.push(tt1)
              }

              const geojson = {
                type: 'FeatureCollection',
                features: [
                  {
                    type: 'Feature',
                    geometry: {
                      type: 'LineString',
                      properties: {},
                      coordinates: coo2,
                    },
                  },
                ],
              }

              // Usar ID único para cada ruta
              const layerId = `route-${routeCounter++}`
              
              // Verificar si la capa ya existe antes de agregarla
              if (mapa.map.getLayer(layerId)) {
                console.log(`⚠️ Capa ${layerId} ya existe, removiendo...`)
                mapa.map.removeLayer(layerId)
              }
              if (mapa.map.getSource(layerId)) {
                mapa.map.removeSource(layerId)
              }

              console.log(`➕ Agregando capa: ${layerId}`)
              mapa.map.addLayer({
                id: layerId,
                type: 'line',
                source: {
                  type: 'geojson',
                  data: geojson,
                  lineMetrics: true,
                },
                layout: {
                  'line-join': 'round',
                  'line-cap': 'round',
                },
                paint: {
                  'line-color': '#0047AB',
                  'line-width': 8,
                },
              })
              
              // Registrar la capa agregada
              this.addedLayers.push(layerId)
              processedRoutes++
              
            } catch (fetchError) {
              clearTimeout(timeoutId)
              if (fetchError.name === 'AbortError') {
                console.log('⚠️ Timeout en llamada a API de Mapbox')
              } else {
                console.error('Error en fetch:', fetchError)
              }
              continue
            }
          }
        }

        /// ///////////////////////////////////////

        // calculando ruta de la pos del driver al punto A
        // obtener primer coordenada del driver
        if (!this.puntosOrden[1]) {
          console.log('⚠️ No hay suficientes puntos de orden')
          return
        }

        const resseg = await this.$store.dispatch('get', { path: `/seguimiento_orden/getById/${this.id}` })
        
        if (!resseg || resseg.length === 0) {
          console.log('⚠️ No se encontró seguimiento de orden')
          return
        }

        console.log('📍 Datos de seguimiento:', resseg)
        this.lat = resseg[0].lat
        this.lng = resseg[0].lng
        console.log('📍 Coordenadas del driver (lat, lng):', this.lat, this.lng)
        console.log('inicio coordenadsas -->', this.puntosOrden[1])
        let puntoini = this.puntosOrden[1].coordenadas_inicio
        puntoini = puntoini.split(',')
        console.log('inini puntoini', puntoini)
        const endPointDriver = `https://api.mapbox.com/directions/v5/mapbox/driving-traffic/${this.lng}%2C${this.lat}%3B${puntoini[1]}%2C${puntoini[0]}?alternatives=true&geometries=geojson&language=en&overview=simplified&steps=true&access_token=pk.eyJ1IjoieWFxdWkiLCJhIjoiY200NTVsdDR1MDYwbzJrb2phODM0dzN5ZCJ9.oBzYf5xlVu_iQUc47GLh1A`

        // consumir servicio con timeout
        const controllerDriver = new AbortController()
        const timeoutIdDriver = setTimeout(() => controllerDriver.abort(), 5000)
        
        try {
          const queryDriver = await fetch(endPointDriver, { 
            method: 'GET',
            signal: controllerDriver.signal,
          })
          clearTimeout(timeoutIdDriver)

          const respDriver = await queryDriver.json()
          
          // Verificar si hay error de autenticación
          if (respDriver.code === 'Unauthorized' || respDriver.message) {
            console.error('❌ Error de API Mapbox (driver):', respDriver.message || 'Token inválido')
            return
          }
          
          if (!respDriver.routes || respDriver.routes.length === 0) {
            console.log('⚠️ No se encontró ruta del driver')
            return
          }

          const cooTmpDriver = respDriver.routes[0].geometry.coordinates
          this.tiempo = (respDriver.routes[0].duration.toFixed(0) / 60).toFixed(2)
          this.distancia = respDriver.routes[0].distance < 1000
            ? respDriver.routes[0].distance.toFixed(2)
            : (respDriver.routes[0].distance / 1000).toFixed(2)
          console.log('lat lng', this.lat, ' ', this.lng)
          console.log('queryDriver', cooTmpDriver)

          const cooDriver2 = []
          for (const it0 of cooTmpDriver) {
            const tt2 = [it0[0], it0[1]]
            cooDriver2.push(tt2)
          }
          console.log('coodriver ---->', cooDriver2)
          const geojson2 = {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                geometry: {
                  type: 'LineString',
                  properties: {},
                  coordinates: cooDriver2,
                },
              },
            ],
          }

          // Verificar si la capa route2 ya existe antes de agregarla
          const driverLayerId = 'route2'
          if (mapa.map.getLayer(driverLayerId)) {
            console.log(`⚠️ Capa ${driverLayerId} ya existe, removiendo...`)
            mapa.map.removeLayer(driverLayerId)
          }
          if (mapa.map.getSource(driverLayerId)) {
            mapa.map.removeSource(driverLayerId)
          }

          console.log(`➕ Agregando capa: ${driverLayerId}`)
          mapa.map.addLayer({
            id: driverLayerId,
            type: 'line',
            source: {
              type: 'geojson',
              data: geojson2,
              lineMetrics: true,
            },
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#FF0000',
              'line-width': 8,
            },
          })
          
          // Registrar la capa agregada
          this.addedLayers.push(driverLayerId)
          
        } catch (fetchError) {
          clearTimeout(timeoutIdDriver)
          if (fetchError.name === 'AbortError') {
            console.log('⚠️ Timeout en llamada a API de Mapbox para driver')
          } else {
            console.error('Error en fetch driver:', fetchError)
          }
        }

        /// /////////////////
        // marcas
        const counter = 4
        const marcas = JSON.parse(localStorage.getItem('marcas')) || []
        let contapuntos = 1
        let imagen = ''

        if (marcas.length > 0) {
          this.marcas = marcas
        } else {
          // this.marcas = [
          //   {
          //     id: 0,
          //     coordinates: [this.lng, this.lat],
          //     lat: this.lat,
          //     lng: this.lng,
          //     title: 'y',
          //     icon: '/yaqui/driver.png',
          //     subtitle: 'mi posición actual',
          //   },
          // ]
          for (const pmarcas of this.puntosOrden) {
            console.log(pmarcas.id)
            let ccord
            ccord = pmarcas.coordenadas_entrega.split(',')

            switch (contapuntos) {
              case 1:
                imagen = 'ayellow0.png'
                break
              case 2:
                imagen = 'bgray0.png' // "byellow0.png";
                break
              case 3:
                imagen = 'cgray0.png'
                break
              case 4:
                imagen = 'dgray0.png'
                break
              case 5:
                imagen = 'egray0.png'
                break
              case 6:
                imagen = 'fgray0.png'
                break
              case 7:
                imagen = 'ggray0.png'
                break
            }
            let data
            if (contapuntos == this.puntosOrden.length) {
              data = {
                id: contapuntos++,
                coordinates: [ccord[1], ccord[0]],
                lat: ccord[0],
                lng: ccord[1],
                title: 'Entrega',
                icon: `/yaqui/${imagen}`,
                subtitle: 'mi posición actual',
                estado: false,
              }
            } else {
              data = {
                id: contapuntos,
                coordinates: [ccord[1], ccord[0]],
                lat: ccord[0],
                lng: ccord[1],
                title: pmarcas.nombre,
                icon: `/yaqui/${imagen}`,
                subtitle: 'mi posición actual',
                estado: false,
              }
            }
            this.marcas.push(data)
            contapuntos++
          }
        }
        console.log('***************************** M A R C A S ******************** ', this.marcas)

        // mapa.map.addMarkers(this.marcas)
      } catch (error) {
        console.log('err *** ', error)
      }
    },
    async updateMap(Mymap) {
      try {
        // Evitar múltiples ejecuciones
        if (this.isLoadingMap) {
          console.log('⚠️ Mapa ya está cargando, evitando duplicación')
          return
        }

        if (this.mapLoaded) {
          console.log('⚠️ Mapa ya fue cargado, evitando duplicación')
          return
        }

        this.isLoadingMap = true
        console.log('🗺️ Iniciando carga del mapa...')

        if (!this.coordinates || this.coordinates.length === 0) {
          console.log('❌ No hay coordenadas para mostrar')
          this.isLoadingMap = false
          return
        }

        this.Mymap = Mymap
        const asyncActions = Mymap.component.actions
        this.center = this.coordinates[0].coordinates
        
        console.log('📍 Centro del mapa:', this.center)
        console.log('📍 Total de coordenadas:', this.coordinates.length)
        
        await asyncActions.flyTo({
          center: this.center,
          zoom: 15, // Zoom más cercano para ver nombres de calles
          speed: 1,
        })

        console.log('✅ FlyTo completado, cargando rutas...')
        await this.showDataOrderInMap(Mymap)
        
        this.mapLoaded = true
        this.isLoadingMap = false
        console.log('✅ Mapa cargado completamente')
      } catch (error) {
        console.error('❌ Error en updateMap:', error)
        this.isLoadingMap = false
        this.mapLoaded = false
      }
    },
    async onMapLoad(event) {
      console.log('📍 Evento onMapLoad disparado')
      
      if (this.coordinates.length === 0) {
        console.log('❌ No hay coordenadas disponibles')
        return
      }
      
      try {
        await this.updateMap(event)
      } catch (error) {
        console.error('❌ Error en onMapLoad:', error)
      }
    },

    showModal(type, item) {
      if (type == 1) {
        this.modalTitle = 'Nueva orden'
        this.row = {}
      } else {
        this.row = item
        this.modalTitle = 'Editar orden'
      }
      this.isDialogVisible = true
    },

    async getData() {
      // alesrt(this.id)
      try {
        this.loading = true
        let res = await this.$store.dispatch('get', { path: `${this.table}/getById/${this.id}` })
        if (res.length > 0) {
          this.items = res
        }

        // obtenemos data orden
        res = await this.$store.dispatch('get', { path: `ordenPlantillaNotificacion/${this.id}` })
        this.loading = false
        console.log('------------', res)
        if (res.length > 0) {
          this.dataOrder = res[0]
          this.puntosOrden = JSON.parse(this.dataOrder.puntos)
        }
      } catch (error) {
        this.dataOrder = []
        this.loading = false
        console.error('error', error)
      }
    },
    
    zoomIn() {
      if (this.Mymap && this.Mymap.map) {
        const currentZoom = this.Mymap.map.getZoom()
        this.Mymap.map.setZoom(currentZoom + 1)
        console.log('🔍 Zoom aumentado a:', currentZoom + 1)
      }
    },
    
    zoomOut() {
      if (this.Mymap && this.Mymap.map) {
        const currentZoom = this.Mymap.map.getZoom()
        this.Mymap.map.setZoom(currentZoom - 1)
        console.log('🔍 Zoom reducido a:', currentZoom - 1)
      }
    },
    
    handleStyleChange(newStyle) {
      console.log('🎨 Cambiando estilo a:', this.selectedMapStyle)
      
      // Si está cambiando a híbrido (satellite-streets), recargar la página
      if (this.selectedMapStyle === 'mapbox://styles/mapbox/satellite-streets-v11') {
        console.log('🔄 Cambiando a híbrido, recargando página...')
        
        // Guardar el estilo seleccionado en localStorage
        localStorage.setItem('mapStyle', this.selectedMapStyle)
        
        // Mostrar mensaje con fondo para que sea visible
        this.isSnackbarVisible = true
        this.snackbar = {
          color: 'primary',
          icon: 'info',
          title: 'Cargando vista híbrida',
          text: 'Recargando para mostrar calles...',
          timeout: 2000,
        }
        
        // Recargar la página después de un breve delay
        setTimeout(() => {
          window.location.reload()
        }, 800)
      } else {
        // Para satélite, solo cambiar el estilo normalmente
        console.log('🛰️ Cambiando a satélite...')
        this.isChangingStyle = true
        this.mapStyle = this.selectedMapStyle
        
        // Guardar el estilo seleccionado
        localStorage.setItem('mapStyle', this.selectedMapStyle)
        
        // Esperar a que el estilo se aplique
        setTimeout(() => {
          this.isChangingStyle = false
          console.log('✅ Estilo cambiado a satélite')
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
